export default __webpack_public_path__ + "static/media/IMG_1081.9ddd03bd.jpg";